import { RecurrencePaymentMethod } from '../../../subscription/subscription.types';

export const SIMULATION_FORM_TEXTS = {
    AD_SPEND: {
        LABEL: 'Last 30d Ad Spend',
    },
    PLAN_SELECTOR: {
        PLACEHOLDER: 'Select a plan',
        LABEL: 'Plan',
    },
    ADDON_SELECTOR: {
        PLACEHOLDER: 'Select addons',
        LABEL: 'Addons',
    },
    SEATS_SELECTOR: {
        PLACEHOLDER: 'Select number of seats',
        LABEL: 'Total Seats',
    },
    CURRENCY_SELECTOR: {
        PLACEHOLDER: 'Select currency',
        LABEL: 'Currency',
    },
    PAYMENT_METHOD: {
        PLACEHOLDER: 'Select Payment Method',
        LABEL: 'Payment Method',
    },
    UNLIMITED_SEATS: 'This plan have unlimited seats.',
    BILL_PAYMENT: {
        CURRENCY_WARNING: 'Bill payments is only allowed for BRL currency and Billing details with address in Brazil',
    },
};

export const FREE_PLAN_ORDER = 1;
export const MAX_SEATS_FOR_DROPDOWN = 20;
export const DEFAULT_CURRENCY_USD = 'USD';
export const BRAZILIAN_CURRENCY = 'BRL';

export const SIMULATION_FORM_DATA_TEST_IDS = {
    PLAN_SELECT_CONTROL: 'plan-select-control',
    PLAN_SELECT_INPUT: 'plan-select-input',
    PLAN_SELECT_OPTION: 'plan-select-option',
    ADDON_SELECT_CONTROL: 'addon-select-control',
    ADDON_SELECT_INPUT: 'addon-select-input',
    ADDON_SELECT_OPTION: 'addon-select-option',
    ADDON_SELECT_MULTI_VALUE_CLOSE: 'addon-select-multi-value-close',
    SEATS_SELECT_CONTROL: 'seats-select-control',
    SEATS_SELECT_OPTION: 'seats-select-option',
    CURRENCY_SELECT_INPUT: 'currency-selector-input',
    CURRENCY_SELECT_OPTION: 'currency-selector-option',
    PAYMENT_METHOD_CONTROL: 'payment-method-control',
    PAYMENT_METHOD_OPTION: 'payment-method-option',
    PAYMENT_METHOD: 'payment-method',
};

export const PAYMENT_METHOD_OPTIONS = [
    {
        label: 'Credit Card',
        value: RecurrencePaymentMethod.STRIPE,
    },
    {
        label: 'Bill Payment',
        value: RecurrencePaymentMethod.BILL_PAYMENT,
    },
];
